import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideNgxMask } from 'ngx-mask';

import { authInterceptorProviders } from '@pkp/core';
import {
  ENVIRONMENTS,
  initializeI18n,
  initializeMenu,
  languageInterceptorProviders,
  MenuService,
} from '@shared/core';
import { LocalizationModule, LocalizationService } from '@shared/modules/localization';
import { MessagesModule } from '@shared/modules/messages';
import { UIFormModule } from '@shared/ui';
import { provideQuillConfig } from 'ngx-quill';
import { environment } from '../../environments/environment';
import { APP_ROUTES } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ENVIRONMENTS,
      useValue: environment,
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(APP_ROUTES, withViewTransitions()),
    provideAnimations(),
    provideNgxMask(),
    importProvidersFrom(LocalizationModule.forRoot()),
    importProvidersFrom(MessagesModule.forRoot()),
    provideHttpClient(withInterceptorsFromDi()),
    authInterceptorProviders,
    languageInterceptorProviders,
    importProvidersFrom(UIFormModule),
    provideAppInitializer(() => {
      const localizationService = inject(LocalizationService);
      return initializeI18n(localizationService)();
    }),
    provideAppInitializer(() => {
      const menuService = inject(MenuService);
      return initializeMenu(menuService)();
    }),
    provideQuillConfig({}),
  ],
};
